import React from "react";
import { Switch, Route } from "react-router-dom";
import Login from "../containers/loginContainer";

function RouterLogin() {
    return (
        <Route path="/">
            <Switch>
                <Route path="/Login" exact>
                    <Login/>
                </Route>
            </Switch>
        </Route>
    );
}
export default RouterLogin;
